import React from 'react'
import { TemplateProps } from '../../journeys/journey/Interfaces';
import { Typography } from "@material-ui/core";
import { Button, Cards } from 'ams-ui-reactkit';
import './downloadPdf.scss'
import DynamicHtml from "../../molecules/DynamicHtml"
import { Welcomeback } from '../../assets/images';

const DownloadPdf: React.FC<TemplateProps> = (props: any) => {
    const { templateProps } = props
    const { script } = templateProps
    const showCloseBtnFlag = process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE ? process.env.REACT_APP_SHOW_CLOSE_ON_LAST_PAGE === "true" : false

    const showCloseButton = () => {

        if (showCloseBtnFlag) {

            return <div className={`mt-8 in-active-btn-download`}>
                <Button
                    text="Close"
                    onClick={() => {
                        window.location.href = "/close"
                    }}
                    color="primary"
                    variant="contained"
                    size="large"
                />
            </div>
        }

        return null;

    }

    return (
        <div className="baseContainerBlock movewithUsBlock">
            {script && <Cards variant="primary">
                <div className="thankyoumainblock">
                    <div className='pdf-download-img'>
                        <img src={Welcomeback} alt="" />
                    </div>
                    <Typography variant="body1" component="span" className="thankyoudesc">
                        <DynamicHtml content={script} />
                    </Typography>
                </div>
            </Cards>}
            <div className="staticFixedButton">
                {showCloseButton()}
            </div>
        </div>
    )
}

export default DownloadPdf
